import * as React from 'react'
import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import AppBar from '../components/AppBar'
import Toolbar from '../components/Toolbar'


const rightLink = {
    fontSize: 16,
    color: 'common.white',
    ml: 3,
}

function AppAppBar() {
    return (
        <>
        <AppBar position="fixed">
            <Toolbar sx={{ justifyContent: 'space-between' }}>
                <Box sx={{ flex: 1 }} />
                <Box sx={{mr: 2}}>
                    <img alt="logo" src="/static/church/logo-clean.png" height={48}/>
                </Box>
                <Link
                    variant="h6"
                    underline="none"
                    color="inherit"
                    href="/"
                    sx={{ fontSize: 24 }}
                    >
                    {'King God Mighty One'}
                </Link>
                <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                    {/* <Link
                        color="inherit"
                        variant="h6"
                        underline="none"
                        href="/"
                        sx={rightLink}
                        >
                        {'About'}
                    </Link>
                    <Link
                        variant="h6"
                        underline="none"
                        href="/"
                        sx={rightLink}
                        // sx={{ ...rightLink, color: 'secondary.main' }}
                        >
                        {'Ministry'}
                    </Link>
                    <Link
                        color="inherit"
                        variant="h6"
                        underline="none"
                        href="/"
                        sx={rightLink}
                        >
                        {'Resources'}
                    </Link>
                    <Link
                        color="inherit"
                        variant="h6"
                        underline="none"
                        href="/"
                        sx={rightLink}
                        >
                        {'Give'}
                    </Link>
                    <Link
                        color="inherit"
                        variant="h6"
                        underline="none"
                        href="/"
                        sx={rightLink}
                        >
                        {'Contact Us'}
                    </Link> */}
                </Box>
            </Toolbar>
        </AppBar>
        <Toolbar />
        </>
    )
}

export default AppAppBar
